<ng-container *transloco="let t">
  <ng-container *ngIf="exercise !== null && ac !== null">
    <button *ngIf="auth.isModerator()" pButton type="button" (click)="data.openExerciseSettings(exercise?.id, 'settings')" icon="pi pi-bars" class="p-button-text" [pTooltip]="t('common.labels.settings')" tooltipPosition="bottom"></button>
    <button *ngIf="auth.isModerator() || group.isGroupModerator(auth.getHashedId())" pButton type="button" (click)="op.toggle($event)" icon="pi pi-step-forward" class="p-button-text p-ml-1" [pTooltip]="t('common.labels.control')" tooltipPosition="bottom"></button>
    <p-overlayPanel #op [dismissable]="true">
      <ng-template pTemplate>
        <div class="agenda content-controls" style="min-width: 300px">
          <div class="group-container">

            <!-- TEAM -->
            <ng-container *ngIf="ac.isGroup() && exercise.isTeam()">
              <ng-container *ngFor="let candidate of group.candidates">
                <app-avatar
                  [user]="candidate"
                  [type]="'candidate'"
                  [mode]="'small'"
                ></app-avatar>
              </ng-container>
              <div class="slot-list group">
                <ng-container *ngFor="let slot of slots">
                  <app-agenda-exercise-slot
                    [slot]="slot"
                    [group]="group"
                  ></app-agenda-exercise-slot>
                </ng-container>
              </div>
            </ng-container>

            <!-- INDIVIDUAL -->
            <ng-container *ngIf="ac.isGroup() && exercise.isIndividual()">
              <ng-container *ngFor="let candidate of group.candidates; index as i">
                <div class="individual-container">
                  <app-avatar
                    [user]="candidate"
                    [type]="'candidate'"
                    [mode]="'small'"
                  ></app-avatar>
                  <div class="slot-list group">
                    <ng-container *ngFor="let slot of slots">
                      <app-agenda-exercise-slot
                        [slot]="slot"
                        [candidate]="candidate"
                        [group]="group"
                        [index]="i"
                      ></app-agenda-exercise-slot>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- SINGLE -->
            <ng-container *ngIf="ac.isSingle()">
              <div class="slot-list group">
                <ng-container *ngFor="let slot of slots">
                  <app-agenda-exercise-slot
                    [slot]="slot"
                    [candidate]="candidate"
                  ></app-agenda-exercise-slot>
                </ng-container>
              </div>
            </ng-container>

          </div>
        </div>
      </ng-template>
    </p-overlayPanel>
  </ng-container>
</ng-container>
